import React from 'react';
import QueryStringNavigate from '../../QueryStringNavigate';

import * as S from './NavMenu.styled';

const ItemMenu = ({ label, href, id, isSubEntry }) => (
  <S.ItemMenu isSubEntry={isSubEntry}>
    <QueryStringNavigate path={href} id={id}>
      {label}
      <S.Underline />
    </QueryStringNavigate>
  </S.ItemMenu>
);

export default ItemMenu;
